/**
 * @param {import('alpinejs').default} Alpine
 */
export default Alpine => {
  /**
   * x-intercept directive
   *
   * Intercepts form GET submissions and link clicks from inside the element which
   * either change just the query parameters or the /page/* part of the URL.
   * All other navigations are not intercepted.
   *
   * Options:
   * - guid: the unique identifier of the document node
   * - morph: whether to morph the element instead of just replacing it (default: true)
   * - viewTransition: use browser-native View Transitions if available
   *
   * The directive emits two events on the element that attempted to navigate:
   * - before-intercept: dispatched before the interception happens.
   *   The event is cancelable. If the event is canceled, the interception is not performed.
   * - after-intercept: dispatched after the interception happened.
   *
   * Both events have a detail object with the following properties:
   * - guid: the unique identifier of the document node
   * - morph: whether the element should be/was morphed instead of just replaced
   * - page: the page number that was navigated to
   * - queryParams: the query parameters that should be/were applied
   *
   */
  Alpine.directive('intercept', async (element, directive, utilities) => {
    // We only load the interceptor if the page has a replaceable element
    // since the interceptor has a non-trivial amount of code and
    // is not needed immediately after page initialization
    const { runInterceptor } = await import('./intercept-lib.js')
    runInterceptor(element, directive, utilities)
  })
}
